export const bulkDownloadMenuName = 'Menu::MenuG:BulkDownloadLog';
